import { createContext, useContext, useState, useRef, useEffect } from "react"
import { login, register, verifyOtp, resendOtp } from "../services/AuthService"
import { useNavigate } from "react-router-dom"

const AuthContext = createContext()

export const AuthProvider = ({children}) => {
    const navigate = useNavigate()
    const [loadingSuccess, setLoadingSuccess]= useState(false)
    const [message, setMessage] = useState("")
    
    const timeoutRef = useRef();

    const loginAction = async (data) => {
        setLoadingSuccess(true)
        try {
            const response = await login(data)            
            if (response && response.status === 200) {
                const resData = response.data 
                const accessToken = resData.content.token
                const urlTypeForm = resData.content.urlTypeForm
                localStorage.setItem("site", accessToken)
                localStorage.setItem("typeForm", urlTypeForm)
                setMessage("Login success");
                navigate("/home")
            }
        } catch (err) {
            setLoadingSuccess(false)
            if (err.response.status === 404) {
                setMessage("Registration failed");
                return err.response;
            }
        } finally {
            setLoadingSuccess(false)
        }
   }

    const registerAction = async (data) => {
        setLoadingSuccess(true);
        try {
            const response = await register(data);
            if (response && response.status === 200) {
                const resData = response.data;
                const userId = resData.content;
                setMessage("Registration success");
                navigate("/verify-otp", { state: { userId: userId } });
            } else {
                setMessage("Registration failed");
                return response;
            }
        } catch (err) {
            setMessage("Registration error");
            setLoadingSuccess(false);
            return err.response;
        } finally {
            setLoadingSuccess(false);
        }
    };

    const verifyOtpAction = async (data) => {
        setLoadingSuccess(true);
        try {
            const response = await verifyOtp(data);
            if (response && response.status === 200) {
                const resData = response.data 
                const accessToken = resData.content.token
                const urlTypeForm = resData.content.urlTypeForm
                localStorage.setItem("site", accessToken)
                localStorage.setItem("typeForm", urlTypeForm)
                setMessage("Login success");
                navigate("/home")
            } else {
                setMessage("Validation failed");
                return response;
            }
        } catch (err) {
            setMessage("Validation error");
            setLoadingSuccess(false);
            return err.response;
        } finally {
            setLoadingSuccess(false);
        }
    };

    const resendOtpAction = async (data) => {
        setLoadingSuccess(true);
        try {
            const response = await resendOtp(data);
            if (response && response.status === 200) {
                setMessage("OTP resend success");
                return response;
            } else {
                setMessage("OTP resend success failed");
                return response;
            }
        } catch (err) {
            setMessage("OTP resend success error");
            setLoadingSuccess(false);
            return err.response;
        } finally {
            setLoadingSuccess(false);
        }
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);


   return <AuthContext.Provider value={{ loginAction, registerAction, verifyOtpAction, resendOtpAction, loadingSuccess, message, navigate }}>
    {children}
   </AuthContext.Provider>
}

export default AuthProvider

export const useAuth = () => {
    return useContext(AuthContext)
}

